import React, { useCallback } from "react";
import { SuccessIcon } from "./Icons";
import { ErrorIcon } from "./Icons";
import { FieldProps } from "../../types";
import { validators } from "../../languages";
import InputControl from "./InputControl";
import { formatPrettyPhone } from "../../helpers";

export function PhoneField(props: FieldProps) {
  const { formMethods, fieldClasses, inputWrapperClasses, inputClasses, disabled } = props;

  const phoneValueChange = useCallback(
    (e) => {
      const fieldValueRaw = `${e.target.value}`;
      const fieldValue = formatPrettyPhone(fieldValueRaw);
      formMethods.setValueChange("phone", fieldValue);
    },
    [formMethods]
  );

  return (
    <InputControl
      fieldId="phone"
      fieldName="phone"
      fieldTitlePhraseKey="payment_step.field_labels.phone"
      fieldType="tel"
      fieldClasses={fieldClasses}
      inputWrapperClasses={inputWrapperClasses}
      inputClasses={inputClasses}
      labelClasses={"is-required"}
      formMethods={formMethods}
      handleValueChange={phoneValueChange}
      attributes={{
        disabled: disabled,
        inputMode: "tel",
        autoCorrect: "off",
        autoComplete: "tel",
        "data-lpignore": "true"
      }}
      errorIcon={<ErrorIcon />}
      successIcon={<SuccessIcon />}
      validators={[validators.required, validators.phoneAreaCode, validators.phoneNumber]}
    />
  );
}

export default PhoneField;
